import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import LayoutWrapper from '../components/layouts/LayoutWrapper';

interface PortfolioRouteProps extends RouteProps {
    component: React.ComponentType<any>;
}

const PortfolioRoute = ({ component: Component, ...rest }: PortfolioRouteProps) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                return (
                    <LayoutWrapper>
                        <Component {...props} />
                    </LayoutWrapper>
                );
            }}
        />
    );
};

export default PortfolioRoute;
